// src/lib/Sendbird/types.ts
// Roles for a user in a channel
var Role = {
    OPERATOR: 'operator',
    NONE: 'none',
};

export { Role as R };
//# sourceMappingURL=bundle-D4pWE19I.js.map
